import { render, staticRenderFns } from "./geneldevreraporu.vue?vue&type=template&id=180c5407&scoped=true&"
import script from "./geneldevreraporu.vue?vue&type=script&lang=js&"
export * from "./geneldevreraporu.vue?vue&type=script&lang=js&"
import style0 from "./geneldevreraporu.vue?vue&type=style&index=0&id=180c5407&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c5407",
  null
  
)

export default component.exports